import { styled } from '@mui/material/styles';

import { TabPanel } from '@mui/lab';

const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
    padding: theme.spacing(2, 0, 0),
    height: '100%',
    overflow: 'hidden',
}));

export default StyledTabPanel;
